import CHElement from "./CHElement";
import EntityStats from "./EntityStats";

class Collection {
  constructor(
    public id_user: number,
    public name: string,
    public description: string | undefined,
    public icon: number | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public id_chelements?: number[],
    public chelements?: CHElement[],
  ) {}

  public static EmptyInstance(): Collection {
    return new Collection(-1, "", "", -1);
  }
}

export default Collection;
